import { motion } from "framer-motion";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import {
  Waves, UtensilsCrossed, Wifi, Car, Dumbbell, Wine,
  Flame, Trees, Bath, Tv,
} from "lucide-react";

const AMENITIES = [
  { icon: Waves, label: "Piscina Infinity" },
  { icon: UtensilsCrossed, label: "Chef Privado" },
  { icon: Wifi, label: "WiFi Alta Velocidad" },
  { icon: Car, label: "Estacionamiento" },
  { icon: Dumbbell, label: "Gimnasio" },
  { icon: Wine, label: "Cava de Vinos" },
  { icon: Flame, label: "Fire Pit" },
  { icon: Trees, label: "Jardines Privados" },
  { icon: Bath, label: "Spa & Sauna" },
  { icon: Tv, label: "Home Theater" },
];

export default function Amenidades() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section ref={ref} className="py-28 md:py-40 px-6 lg:px-10 bg-secondary/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 1 }}
            className="text-accent text-sm tracking-[0.3em] uppercase font-light mb-6 block"
          >
            Amenidades
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, delay: 0.1 }}
            className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-light text-foreground text-balance"
          >
            Cada detalle, cuidado
          </motion.h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-border">
          {AMENITIES.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.label}
                initial={{ opacity: 0, y: 20 }}
                animate={isVisible ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, delay: i * 0.05 }}
                className="group bg-background p-8 flex flex-col items-center text-center gap-3 hover:bg-accent/5 transition-colors duration-300"
              >
                <Icon
                  size={40}
                  strokeWidth={1}
                  className="text-accent transition-transform duration-300 group-hover:scale-110"
                />
                <span className="text-sm font-light text-foreground/80">{item.label}</span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}